import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Link, matchPath } from 'react-router-dom';
import { Box, Keyboard, Text } from 'grommet';
import { withTheme } from 'styled-components';
import { ConfigContext } from 'granite-admin/core/components/ConfigProvider';
import MenuButton from 'granite-admin/core/components/MenuButton';
import Divider from 'granite-admin/core/components/Divider';
const getFlatChildrenIds = children => children.reduce((flatChildren, item) => {
  if (item.children) {
    flatChildren.push(item.pk || item.label);
    flatChildren = flatChildren.concat(getFlatChildrenIds(item.children));
  }
  return flatChildren;
}, []);
const VerticalMenu = ({
  data,
  hoverIndicatorOptions,
  isCollapsed,
  pathname,
  offsetHeight,
  sideMenuItem,
  openInNewTab,
  theme
}) => {
  const customConfig = useContext(ConfigContext);
  const {
    VerticalMenu
  } = customConfig?.verticalMenu;
  const defaultExpandedItems = data ? data.map(item => item.children).reduce((acc, val) => acc.concat(val), []).filter(item => item.children && Boolean(matchPath(pathname, {
    path: '/' + item.getpath()
  }))).map(item => item.pk) : [];
  const [expandedItems, setExpandedItems] = useState(defaultExpandedItems);
  const onMenuChange = (item, expanded) => {
    let newExpandedItems = [...expandedItems];
    if (expanded) {
      const toBeCollapsedIds = getFlatChildrenIds([item]);
      newExpandedItems = newExpandedItems.filter(itemId => toBeCollapsedIds.indexOf(itemId) < 0);
    } else {
      newExpandedItems.push(item.pk || item.label);
    }
    setExpandedItems(newExpandedItems);
  };
  const renderItem = (item, level = 0) => {
    const itemId = item.pk || item.getlabel();
    const isExpanded = expandedItems.includes(itemId);
    const itemKey = `item_${itemId}_${level}`;
    const isActive = Boolean(matchPath(pathname, {
      path: '/' + item.getpath()
    })) && !item.children;
    const content = /*#__PURE__*/React.createElement(MenuButton, {
      label: item.getlabel(),
      id: itemId,
      icon: item.geticon(),
      level: level,
      isActive: isActive,
      activeColor: "sidebar-label-active-background",
      isExpandable: item.children && item.children.length > 0,
      isExpanded: isExpanded,
      isCollapsed: isCollapsed,
      hoverIndicatorOptions: hoverIndicatorOptions,
      onClick: () => onMenuChange(item, isExpanded),
      sideMenuItem: sideMenuItem,
      pathname: item.getpath(),
      openInNewTab: openInNewTab,
      offsetHeight: offsetHeight
    });
    return /*#__PURE__*/React.createElement(Box, {
      key: itemKey
    }, item.children ? /*#__PURE__*/React.createElement(Keyboard, {
      onDown: () => this.onMenuChange(item, false),
      onRight: () => this.onMenuChange(item, false),
      onUp: () => this.onMenuChange(item, true),
      onLeft: () => this.onMenuChange(item, true)
    }, content) : /*#__PURE__*/React.createElement(Link, {
      to: {
        pathname: '/' + item.getpath(),
        state: {
          url: item.url
        }
      }
    }, content), item.children && isExpanded && item.children.map(child => renderItem(child, level + 1)));
  };
  return VerticalMenu ? /*#__PURE__*/React.createElement(VerticalMenu, {
    data: data,
    theme: theme,
    renderItem: renderItem,
    isCollapsed: isCollapsed
  }) : /*#__PURE__*/React.createElement(Box, {
    flex: {
      grow: 1
    }
  }, data && data.map(item => {
    return /*#__PURE__*/React.createElement(Box, {
      key: item.group,
      margin: {
        top: 'small',
        bottom: 'xsmall'
      }
    }, /*#__PURE__*/React.createElement(Box, {
      margin: {
        horizontal: 'small'
      }
    }, !isCollapsed && /*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: theme.global.colors['sidebar-label-bold'],
      color: theme.global.colors['sidebar-group']
    }, item.group), /*#__PURE__*/React.createElement(Divider, {
      color: "sidebar-divider",
      margin: {
        bottom: 'xsmall'
      }
    })), item.children.map(child => renderItem(child)));
  }));
};
VerticalMenu.propTypes = {
  hoverIndicatorOptions: PropTypes.object,
  theme: PropTypes.object,
  data: PropTypes.array,
  offsetHeight: PropTypes.number,
  isCollapsed: PropTypes.bool,
  pathname: PropTypes.string,
  sideMenuItem: PropTypes.object,
  openInNewTab: PropTypes.func
};
export default withTheme(VerticalMenu);